var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-stretch" },
    _vm._l(_vm.generalSubscriptionPlansKeys, function (innerSubscriptionName) {
      return _c("PricePlanProvider", {
        key: innerSubscriptionName,
        staticClass: "flex-shrink-0 borders border-primary-color",
        attrs: {
          subscriptionDetails:
            _vm.subscriptionPlansDetails[innerSubscriptionName],
          innerName: innerSubscriptionName,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({
                slogan,
                label,
                title,
                price,
                emphasized,
                benefitsShown,
              }) {
                return [
                  _c(
                    "PriceCardView",
                    {
                      attrs: {
                        title: title,
                        slogan: slogan,
                        price: price,
                        label: label,
                        benefitsShown: benefitsShown,
                        managersCount: _vm.getManagersCount(
                          _vm.subscriptionPlansDetails[innerSubscriptionName]
                        ),
                        emphasized: emphasized,
                        subscriptionPlanId:
                          _vm.subscriptionPlansDetails[innerSubscriptionName]
                            .id,
                        currentSubscription: _vm.currentSubscription,
                        generalSubscriptionPlans: _vm.generalSubscriptionPlans,
                        activeManagersCount: _vm.activeManagersCount,
                        checkIfPlanIsPremium: _vm.isPremiumPlanAndCurrentPlan(
                          innerSubscriptionName
                        ),
                      },
                    },
                    [
                      [
                        _vm._t("default", null, {
                          subscriptionPlanId:
                            _vm.subscriptionPlansDetails[innerSubscriptionName]
                              .id,
                          currentSubscriptionId: _vm.currentSubscriptionId,
                          title: title,
                          slogan: slogan,
                          price: price,
                          label: label,
                          benefitsShown: benefitsShown,
                          managersCount: _vm.getManagersCount(
                            _vm.subscriptionPlansDetails[innerSubscriptionName]
                          ),
                        }),
                      ],
                    ],
                    2
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }